export enum enmFactSheetDataType {
    bool = 1,
    int = 2,
    string = 3,
    float = 5
}